@if ({ unreadData: unreadReplies$ | async }; as counter) {
  @if (counter.unreadData) {
    <div class="counter">
      <app-text
        [textSize]="TextSizes.qty"
        [textType]="TextType.base"
        [text]="counter.unreadData.toString()"
      ></app-text>
    </div>
  }
}
